"use strict";
/// <reference path="irep.js"/>

IREP.dashboard = (function () {
    var alertmsg, spnUploadStatus, collapseProfileMsg, editProfileMsg, collapsePasswordMsg, editPasswordMsg, divEditProfileText, aInbox,
        divInboxPlaceHolder, divEditPasswordText, ErrorBrowserNotSupported, ErrorTooManyFiles, ErrorFileTooLarge, InvalidFileDetails, InvalidFileType, ErrorText;
    
    var init = function (options) {
        alertmsg = options.alert;
        collapseProfileMsg = options.collapseProfileMsg;
        editProfileMsg = options.editProfileMsg;
        collapsePasswordMsg = options.collapsePasswordMsg;
        editPasswordMsg = options.editPasswordMsg;
        spnUploadStatus = options.spnUploadStatus;
        divEditProfileText = options.divEditProfileText;
        aInbox = options.aInbox;
        divInboxPlaceHolder = options.divInboxPlaceHolder;
        divEditPasswordText = options.divEditPasswordText;
        ErrorBrowserNotSupported = options.ErrorBrowserNotSupported;
        ErrorTooManyFiles = options.ErrorTooManyFiles;
        ErrorFileTooLarge = options.ErrorFileTooLarge;
        InvalidFileDetails = options.InvalidFileDetails;
        InvalidFileType = options.InvalidFileType;
        ErrorText = options.ErrorText;

        //Euronics Integration users are assigned a pre-set password, if they didn't change their password --> hide 'update password' in dashboard
        // did user update a password after it was auto-created for Euronics Integration(store chain id 884)?
        IREP.callApi("euronics/isOriginalPassword", "GET").done(function (data) {
            if (data.isOriginalPassword === 0) {

                $(divEditPasswordText).click(function () {
                    ExpandCollapsePassword();
                });
            }
            else {
                //hide 'change password'
                $(divEditPasswordText).hide();
            }
        });

        $(divEditProfileText).click(function () {
            ExpandCollapse();
            return false;
        });

        $(aInbox).click(function () {
            ExpandCollapseInbox();
            return false;
        });
        $(".chooseFile").click(function () {
            $("#divOverlayHolder").show();
            $("#uploadPhotoOverlay").show();
            $("#dvUploadButtonHolder").show();
            $("#uploadPhotoOverlay").height($(document).height());
            $("#divChangeAvatarPopup").css("z-index", 12);
            $(".divInnerPopup").hide();
            $("#uploadButton").show();
            $("#dropbox").show();
            $(".message").show();
            $(".preview").remove();
        });

        $("#dvCloseUploadButton").on("click", function () {
            $("#divOverlayHolder").hide();
            $("#uploadPhotoOverlay").hide();
            $(".divInnerPopup").show();
            removeImages();
            $(".preview").remove();
        });

        $("#btnSubmitCrop").on("click", function () {
            $(this).hide(); 
        });

        $("#uploadButton").on("click", function () {
            $(this).hide();
        });

        if (document.documentMode <= 10) {
            configureIEMode();
        }
        initDropBox();
        $(window).resizeDebounce({
            runOnStart: true,
            timeoutDelay: 100
        });
    };

    $("#dvCloseUploadButton2").on("click", function () {
        $("#uploadPhotoOverlay").hide();
        window.open(window.location.href, "_self");
    });

    $(".lnkCancel").click(function () {
        $("#divChangeAvatarPopup").css("display", "none");
        $(spnUploadStatus).html("");
        $("#divAvatarTransparent").css("display", "none");
        $("#aEditProfile").html(editProfileMsg);
        return false;
    });

    var configureIEMode = function () {
        $("#uploadButton").hide();
        $("#dvFileWrapper").show();
        $("#dvFileWrapper").css("width", "500px");
        $("#dvFileWrapper").css("height", "200px");
        $("#dropbox").hide();
    }

    var ExpandCollapseInbox = function () {
        if ($(divInboxPlaceHolder).css("display") === "none") {
            $(divInboxPlaceHolder).css("display", "block");
        }
        else {
            $(divInboxPlaceHolder).css("display", "none");
        }
    }

    var ExpandCollapsePassword = function () {

        if ($("#divEditPasswordPlaceHolder").css("display") === "none") {
            $("#divEditPasswordPlaceHolder").slideDown();
            $("#aEditPassword").html(collapsePasswordMsg);
            if ($("#divEditProfilePlaceHolder").css("display") === "block")
            {
                $("#divEditProfilePlaceHolder").slideUp();
                $("#aEditProfile").html(editProfileMsg);
                
            }
        }
        else {
            $("#divEditPasswordPlaceHolder").slideUp();
            $("#aEditPassword").html(editPasswordMsg);
            $("#divError").hide(); //clear out any messages after editing profile
        }
    }

    var ExpandCollapse = function () {

        if ($("#divEditProfilePlaceHolder").css("display") === "none") {
            //$("#divEditProfilePlaceHolder").css("display", "block");
            $("#divEditProfilePlaceHolder").slideDown();
            $("#aEditProfile").html(collapseProfileMsg);
            $("#divAvatarTransparent").css("display", "block");
            if ($("#divEditPasswordPlaceHolder").css("display") === "block") {
                $("#divEditPasswordPlaceHolder").slideUp();
                $("#aEditPassword").html(editPasswordMsg);
            }
        }
        else {
            //$("#divEditProfilePlaceHolder").css("display", "none");
            $("#divEditProfilePlaceHolder").slideUp();
            $("#aEditProfile").html(editProfileMsg);
            $("#divError").hide(); //clear out any messages after editing profile
            $("#divAvatarTransparent").css("display", "none");
            $("#divChangeAvatarPopup").css("display", "none");
        }
    }

    var RefreshParticipantInfo = function () {
        IREP.leaderboard.block($("#divHeader"));
        
        IREP.callApi("participant/dashboardinfo", "GET")
            .done(function (data) {
                if (data != null) {
                    $("#divNameStatus").html(data.participantDashboardInfo.name);
                    $("#divLocationData").html(data.participantDashboardInfo.location);
                    $("#divCompanyData").html(data.participantDashboardInfo.storeChain);
                }
                ($("#divHeader")).unblock();
            })
            .fail(function () {
                ($("#divHeader")).unblock();
            })

    }

    var ChangeAvatar = function () {
        if ($("#divChangeAvatarPopup").css("display") === "none") {
            $("#divChangeAvatarPopup").css("display", "block");
            $("#divEditProfilePlaceHolder").css("display", "none");
            $(".divInnerPopup").show();
        }
        else $("#divChangeAvatarPopup").css("display", "none");
    }

    var ValidateUpload = function(alertmsg, spnUploadStatus) {
        if (alertmsg != "") {
            $(spnUploadStatus).html(alertmsg);
            $(spnUploadStatus).css('color', 'red');
            $("#divAvatarTransparent").css("display", "block");
            $("#divChangeAvatarPopup").css("display", "block");
            return false;
        } else {
            return true;
        }
    }

    var dropbox = $('#dropbox'),
        message = $('.message', dropbox);

    var removeImages = function () {
        //Remove existing dynamic items if found. (Needed for close & re-open overlay)
        $("#uploadedImage").remove();
        $(".jcrop-holder").remove();
        $(".innerPreview").remove();
        $(".preview").remove();
    };

    var showCropper = function (fileName, fileDisplayName) {
        $("#dvUploadButtonHolder").hide();
        removeImages();

        //Append the image to the container. 
        $("#dvUploadedImage").append($("<img id='uploadedImage' class='uploadedImage'>").attr('src', "/api/participant/avatar/uploadedimage/" + fileName + "?width=500&height=500&mode=max"));

        $("#uploadedImage").bind("load", function () {
            //When the appended element has finished loading, then we want to show the cropper and link it to the uploaded image. 
            // If you do it before, then the 
            $(".image-cropper").show();
            $('.image-cropper').each(linkUp);
        });
        $("#dvUploadedImage").show();
        $("#btnSubmitCrop").show();
    };

    var initDropBox = function () {
        dropbox.filedrop({
            paramname: 'pic',
            maxfiles: 1,
            maxfilesize: 2, //in MB
            url: window.location.href.split('?')[0] + '/AvatarUpload', //Uses AvatarUpload.aspx in the pages\dashboard directory. 

            uploadFinished: function (i, file, response) {
                //Upon upload completion, we want to hide the drop area and show the cropper control. 
                $.data(file).addClass('done');

                showCropper(response[1], response[2]);
            },

            error: function (err, file) {
                switch (err) {
                    case 'BrowserNotSupported':
                        showMessage(ErrorBrowserNotSupported);
                        break;
                    case 'TooManyFiles':
                        alert(ErrorTooManyFiles);
                        break;
                    case 'FileTooLarge':
                        alert(file.name + ErrorFileTooLarge);
                        break;
                    default:
                        break;
                }
            },

            //Function renders a progress indicator for uploads.
            uploadStarted: function (i, file, len) {
                if (checkFileName(file.name)) {
                    createImage(file);
                }
                else {
                    alert(InvalidFileDetails);
                    return false;
                }
            },

            //Updates the progress bar. 
            progressUpdated: function (i, file, progress) {
                $.data(file).find('.progress').width(progress);
            }

        });
    }

    //Holder for images being uploaded. 
    var template = '<div class="preview">' +
                        '<span class="imageHolder">' +
                            '<img />' +
                            '<span class="uploaded"></span>' +
                        '</span>' +
                        '<div class="progressHolder">' +
                            '<div class="progress"></div>' +
                        '</div>' +
                    '</div>';

    function createImage(file) {

        var preview = $(template),
            image = $('img', preview);

        var reader = new FileReader();

        image.width = 200;
        image.height = 200;

        reader.onload = function (e) {

            // e.target.result holds the DataURL which
            // can be used as a source of the image:
            //alert(e.target.result);
            image.attr('src', e.target.result);
        };

        // Reading the file as a DataURL. When finished,
        // this will trigger the onload function above:
        reader.readAsDataURL(file);

        message.hide();
        preview.appendTo(dropbox);

        // Associating a preview container
        // with the file, using jQuery's $.data():

        $.data(file, preview);
    }

    function showMessage(msg) {
        message.html(msg);
    }

    function linkUp(unusedIndex, container) {
        container = $(container); //We were passed a DOM reference, convert it to a jquery object

        //The code will look for a img.image, a div.preview, a.result, an input.result inside the specified container, and link them together.
        //Only 'img.image' is required, however.  

        //Find the original image
        var image = container.find("img#uploadedImage");

        //Find the aspect ratio of the image
        var targetRatio = $(".croppedPreview").width() / $(".croppedPreview").height();
        var keepRatio = true;

        //jCrop will enforce this ratio:
        var forcedRatio = keepRatio ? targetRatio : null;

        //Find the URL of the original image minus the querystring.
        var path = image.attr('src');
        if (path.indexOf('?') > 0) path = path.substr(0, path.indexOf('?'));

        //Find the preview div(s) (if they exist) and make sure the have a set height and width.
        var divPreview = container.find("div.croppedPreview");

        //What size to make the preview window (defaults to existing width/height if specified in 'style' attribute)
        var previewFallbackWidth = 200;
        var previewFallbackHeight = 200;

        //Allow the div to override the default width and height in the style attribute
        var previewMaxWidth = (divPreview.attr('style') != null && divPreview.attr('style').indexOf('width') > -1) ? divPreview.width() : previewFallbackWidth;
        var previewMaxHeight = (divPreview.attr('style') != null && divPreview.attr('style').indexOf('height') > -1) ? divPreview.height() : previewFallbackHeight;
        //Set the values explicitly.
        divPreview.css({
            width: previewMaxWidth + 'px',
            height: previewMaxHeight + 'px',
            overflow: 'hidden'
        });

        //Create another child div and style it to form a 'clipping rectangle' for the preview div.
        var innerPreview = $('<div />').css({
            overflow: 'hidden'
        }).addClass('innerPreview').appendTo(divPreview);

        //Create a copy of the image inside the inner preview div(s)
        $('<img />').attr('src', image.attr('src')).appendTo(innerPreview);

        //And any input fields (for postbacks, if desired)
        var inputs = container.find('input.result');


        //Create a function to update the link, hidden input, and preview pane
        var update = function (coords) {
            if (parseInt(coords.w) <= 0 || parseInt(coords.h) <= 0) return; //Require valid width and height

            //The aspect ratio of the cropping rectangle. If 'keepRatio', use targetRatio since it's more precise.
            var cropRatio = keepRatio ? targetRatio : (coords.w / coords.h);

            //When the selection aspect ratio changes, the preview clipping area has to also.
            //Calculate the width and height.
            var innerWidth = cropRatio >= (previewMaxWidth / previewMaxHeight) ? previewMaxWidth : previewMaxHeight * cropRatio;
            var innerHeight = cropRatio < (previewMaxWidth / previewMaxHeight) ? previewMaxHeight : previewMaxWidth / cropRatio;

            innerPreview.css({
                width: Math.ceil(innerWidth) + 'px',
                height: Math.ceil(innerHeight) + 'px',
                marginTop: (previewMaxHeight - innerHeight) / 2 + 'px',
                marginLeft: (previewMaxWidth - innerWidth) / 2 + 'px',
                overflow: 'hidden'
            });

            //Calculate how much we are shrinking the image inside the preview window
            var scalex = innerWidth / coords.w;
            var scaley = innerHeight / coords.h;

            //Set the width and height of the image so the right areas appear at the right scale appear.
            innerPreview.find('img').css({
                width: Math.round(scalex * image.width()) + 'px',
                height: Math.round(scaley * image.height()) + 'px',
                marginLeft: '-' + Math.round(scalex * coords.x) + 'px',
                marginTop: '-' + Math.round(scaley * coords.y) + 'px'
            });

            //Calculate the querystring
            var query = '&';

            //Add final size, if specified.
            query += 'maxwidth=' + $(".croppedPreview").width() + '&';
            query += 'maxheight=' + $(".croppedPreview").height() + '&';

            //Add crop rectangle
            query += 'crop=(' + coords.x + ',' + coords.y + ',' + coords.x2 + ',' + coords.y2 + ')&cropxunits=' + image.width() + '&cropyunits=' + image.height();

            //Now, update the links and input values.
            //links.attr('href', "PhotoShareSubmission?name=" + path + query);
            //links.attr('target', '_blank');
            $("#txtRequestString").val("name=" + path + query);
            inputs.attr('value', path + query);
        };


        //Preview window initialization. Based on the aspect ratio, do the initial selection. 
        var sourceRatio = image.width() / image.height();
        var newWidth = divPreview.width();
        var newHeight = divPreview.height();
        var startX = 0;
        var startY = 0;

        //Our viewing area is 300x200. If the ratio of the source image is smaller, then we calculate the display area based on the image width. 
        //      Otherwise, we calculate based on image height. We want to maximize our selection as much as possible. 
        //      X = TargetRatio * Y. 
        if (targetRatio > sourceRatio) {
            newWidth = image.width();
            newHeight = image.width() / targetRatio; //Divide by the ratio because the ratio is width based and we're calculating the Y off the X.
            startX = 0; //We have all the width of the image. Height is the variable
            startY = (image.height() - newHeight) / 2; //Center the crop area.
        }
        else {
            newWidth = image.height() * targetRatio; //Multiply by the ratio because the ratio is width based and we're calculating the X off the Y. 
            newHeight = image.height();
            startX = (image.width() - newWidth) / 2;
            startY = 0; //We have all the height of the image. Width is the variable
        }

        //Start up jCrop
        var jcrop_reference = $.Jcrop(image);
        jcrop_reference.setOptions({
            onChange: update,
            onSelect: update,
            aspectRatio: forcedRatio,
            bgColor: 'black',
            bgOpacity: 0.6
        });

        jcrop_reference.setSelect([startX, startY, newWidth + startX, newHeight + startY]); //Set the initial selection window.
    };

    var fileUploaded = function (sender, args) {
        //Called when the user uploads a file via the 'Choose a file' button. We need to transition to step 2 using the JSON that is sent back. 
        showCropper($.trim($("#dvAsyncUploadGuid").html()), args.get_fileName());
    };

    var checkFileName = function (fileName) {
        var ext = fileName.substring(fileName.lastIndexOf(".") + 1).toLowerCase();
        if (ext != "png" && ext != "gif" && ext != "jpg" && ext != "tif" && ext != "bmp") {
            return false;
        }
        return true;
    };

    var uploadStarted = function (sender, args) {
        //When the upload starts, validate the file type. Throw an error which results in a popup message for the user that their image is an invalid type. 
        var filename = args.get_fileName();
        if (!checkFileName(filename)) {
            throw {
                name: InvalidFileType,
                level: ErrorText,
                message: InvalidFileDetails,
                htmlMessage: InvalidFileDetails
            }
            return false;
        }
        return true;
    };

    return {
        init: init,
        ExpandCollapse: ExpandCollapse,
        RefreshParticipantInfo: RefreshParticipantInfo,
        ChangeAvatar: ChangeAvatar,
        ValidateUpload: ValidateUpload,
        ExpandCollapseInbox: ExpandCollapseInbox,
        ExpandCollapsePassword: ExpandCollapsePassword,
        fileUploaded: fileUploaded,
        uploadStarted: uploadStarted
    };
})();

